// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import Rails from "@rails/ujs"
import "@fortawesome/fontawesome-free/js/all"
Rails.start()
import jquery from "jquery"
window.$ = window.jquery = jquery
import "mediaelement/full"
import "bootstrap"
import "select2"
import "daterangepicker"
import moment from 'moment'
window.moment = moment
require("adminlte.min")
require("jquery.inputmask")
require("bootstrap-colorpicker.min")
require("jquery-ui")
global.toastr = require("toastr")
require("@nathanvda/cocoon")
import "./associations_benefit"
import "./survey"

$(function () {
  var remoteLinks = document.querySelectorAll('a[data-remote=\'true\']');

  for (var i = 0; i < remoteLinks.length; i++) {
    var link = remoteLinks[i];
    link.dataset.url = link.href;
    link.setAttribute('href', 'javascript:void(0);');
  }

  $.rails.href = function(element) {
    if (element.dataset) {
      var url = element.dataset.url || element.dataset.href;
      if (url) { return url; }
    }
    return element.href;
  }

  mediaPlayer();
});

$(document).ready(function() {
  // Handle modal triggers (e.g., "Rate this Perk")
  $(document).on('click', '.modal-trigger', function(e) {
    e.preventDefault();
    e.stopPropagation(); // Prevent bubbling to other elements
    const modalId = $(this).data('modal'); // e.g., 'modal-benefit-cta' or 'modal-show'

    // Open the targeted modal without closing others
    $(`#${modalId}`).addClass('is-visible');
    if (modalId === 'modal-benefit-cta') {
      $(`#${modalId}`).css('z-index', '10000');
      $('.modal-overlay').css('z-index', '9999'); // Below #modal-benefit-cta
    } else {
      $(`#${modalId}`).css('z-index', '1000');
      $('.modal-overlay').addClass('is-visible').css('z-index', '999'); // Below #modal-show
    }

    // Focus on first input for accessibility
    $(`#${modalId} .modal-content`).find('input, button, select, textarea').first().focus();
  });

  // Close topmost modal on outside click
  $(document).on('click', '.modal, .modal-overlay', function(event) {
    if ($(event.target).hasClass('modal') || $(event.target).hasClass('modal-overlay')) {
      event.stopPropagation(); // Prevent bubbling to other modals or overlays
      // Find the topmost modal (highest z-index)
      let topModal = null;
      let highestZ = -1;
      $('.modal.is-visible').each(function() {
        const zIndex = parseInt($(this).css('z-index')) || 0;
        console.log(`Outside click - Modal ID: ${$(this).attr('id')}, z-index: ${zIndex}`); // Debug log
        if (zIndex > highestZ) {
          highestZ = zIndex;
          topModal = $(this);
        }
      });
      if (topModal) {
        console.log(`Closing top modal (outside click): ${topModal.attr('id')}`); // Debug log
        topModal.removeClass('is-visible');
        if (topModal.is('#modal-benefit-cta')) {
          topModal.css('z-index', '0');
          $('.modal-overlay').css('z-index', '999'); // Adjust for remaining modals
        } else if (topModal.is('#modal-show')) {
          $('.modal-overlay').removeClass('is-visible'); // Hide overlay with #modal-show
        }
      } else {
        console.log('No top modal found for outside click');
      }
    }
  });

  // Close topmost modal on Escape key
  $(document).on('keydown', function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      event.stopPropagation(); // Prevent other handlers
      // Find the topmost modal (highest z-index)
      let topModal = null;
      let highestZ = -1;
      $('.modal.is-visible').each(function() {
        const zIndex = parseInt($(this).css('z-index')) || 0;
        console.log(`Escape key - Modal ID: ${$(this).attr('id')}, z-index: ${zIndex}`); // Debug log
        if (zIndex > highestZ) {
          highestZ = zIndex;
          topModal = $(this);
        }
      });
      if (topModal) {
        console.log(`Closing top modal (Escape): ${topModal.attr('id')}`); // Debug log
        topModal.removeClass('is-visible');
        if (topModal.is('#modal-benefit-cta')) {
          topModal.css('z-index', '0');
          $('.modal-overlay').css('z-index', '999'); // Adjust for remaining modals
        } else if (topModal.is('#modal-show')) {
          $('.modal-overlay').removeClass('is-visible'); // Hide overlay with #modal-show
        }
      } else {
        console.log('No visible modals found for Escape key');
      }
    }
  });

  // Handle close buttons globally
  $(document).on('click', '.modal-close', function(event) {
    event.stopPropagation(); // Prevent bubbling
    const modal = $(this).closest('.modal');
    console.log(`Closing modal (close button): ${modal.attr('id')}`); // Debug log
    modal.removeClass('is-visible');
    if (modal.is('#modal-benefit-cta')) {
      modal.css('z-index', '0');
      $('.modal-overlay').css('z-index', '999');
    } else if (modal.is('#modal-show')) {
      $('.modal-overlay').removeClass('is-visible');
    }
  });
});

function mediaPlayer() {
  $('audio, video').mediaelementplayer({
    // When using jQuery's `mediaelementplayer`, an `instance` argument
    // is available in the `success` callback
    features: ['playpause', 'progress', 'current', 'duration', 'volume', 'fullscreen'],
    alwaysShowControls: true,
    stretching: 'responsive',
    success: function(mediaElement, originalNode, instance) {
      // do things
    }
  });
}
